import './App.css';
import {BrowserRouter as Router, Route, Routes, Link} from "react-router-dom";

import Inicio from "./componentes/Inicio";
import Expediciones from "./componentes/Expediciones";
import Contacto from "./componentes/Contacto";
import TurismoCerca from "./componentes/TurismoCerca";
import AcercaDe from "./componentes/AcercaDe";
import NavBar from "./componentes/NavBar";
import Pie from "../src/componentes/pie.js";
import Reservas from "./componentes/Reservas";


import CajaGenerica from "./componentes/CajaGenerica";
import CajaVacia from "./componentes/CajaVacia";
import CajaTextoRosa from "./componentes/CajaTextoRosa";
import {React} from "react";
const imagen1 = "portada1.png"
const imagen2 = "foto10.jpg"

function App() {
  return (
      <Router>
          <div className="cabecera">
              <NavBar/>
          </div>
          <div className="contenedor-principal" style={{zIndex:"1", paddingTop:"32%"}}>
              <Routes>
                  <Route path="/" element={<Inicio/>}/>
                  <Route path="/inicio" element={<Inicio/>}/>
                  <Route path="/reservas" element={<Reservas/>}/>
                  <Route path="/expediciones" element={<Expediciones/>}/>
                  <Route path="/contacto" element={<Contacto/>}/>
                  <Route path="/turismo-cerca" element={<TurismoCerca/>}/>
                  <Route path="/acerca-de" element={<AcercaDe/>}/>
                  </Routes>
              <section id={"turismo-en-catamarca"} className={"turismo-cerca"}>
                  <CajaTextoRosa
                      icon={"landscape"}
                      destacado={"Pedaleá sin preocupaciones"}
                      titulo={"Nosotros nos ocupamos de todo"}
                      descripcion={"Imaginá despertar con la montaña frente a vos, la bici lista y todo preparado para que solo disfrutes el camino. No tenés que pensar en dónde dormir, qué comer o cómo llegar: nosotros nos ocupamos de todo."}

                  />
                  <div className="contenedor-imagenes"></div>

              </section>
              <section id={"aventura-en-seismiles"}>
                  <CajaVacia

                      encabezado={"Un destino ideal"}
                      titulo={"para una escapada o viaje, ya sea solo, con amigos o en familia"}
                      descripcion={
                          "Pedalear cerca de los volcanes más altos del mundo, disfrutar de las termas, dunas mágicas, conocer la cultura de los pueblos y degustar la gastronomía local son algunas de las actividades que podés realizar.\n\n" +
                          "Julieta, ciclista apasionada y referente femenina, te acompaña en cada rodada para que ganes confianza, aprendas lo esencial del ciclismo y descubras paisajes que te van a dejar sin aliento.\n\n" +
                          "Yo, Tomás, me encargo de la logística y de que cada detalle esté resuelto: desde buscarte en tu casa hasta acompañarte en la camioneta por cualquier eventualidad.\n\n" +
                          "En grupos reducidos de hasta tres personas, cada salida es más que una expedición: es un viaje de aprendizaje, cuidado y conexión. Ya sea en las majestuosas rutas de los Seismiles en Tinogasta o en los encantos serranos de Córdoba, tu única tarea es pedalear y disfrutar."
                      }
                      boton={"Descubrí Más"}
                  />
                  <div className="contenedor-imagenes"></div>
              </section>
              <section id={"placeres-en-catamarca"} className={"turismo-cerca"}>
                  <CajaGenerica style={{background: "#1b1924"}}
                                icon={"wine_bar"}
                                titulo={"Placeres en Catamarca"}
                                texto={"La Ruta del Vino en Tinogasta, ubicada en la provincia de Catamarca, ofrece a los visitantes la oportunidad de descubrir la riqueza vitivinícola de la región. Tinogasta se encuentra en el Valle de Abaucán, una zona con un clima propicio para el cultivo de la vid y la producción de vinos de calidad."}
                  />
              </section>
              <section id={"alojamientos-en-fiambala"} className={"turismo-cerca"}>
                  <CajaGenerica
                      icon={"hotel"}
                      titulo={"Alojamientos"}
                      texto={"En la zona, los visitantes pueden encontrar una amplia variedad de alojamientos para todos los gustos y presupuestos. Desde hoteles de lujo hasta hostales y cabañas, la oferta es variada y se adapta a las necesidades de cada viajero."}
                  />
              </section>
              <section id={"ubicacion-en-catamarca"} className={"turismo-cerca"}>
                  <CajaGenerica
                      icon={"location_on"}
                      titulo={"Ubicación"}
                      texto={"La Ruta de los Seismiles es un recorrido que concentra más de 15 cumbres de la Cordillera de Los Andes que superan los 6.000 metros de altura sobre el nivel del mar (msnm). Entre ellos, es posible distinguir el Volcán Ojos del Salado, Incahuasi, Pissis y Nevado Tres Cruces"}
                  />
              </section>
              <section id={"faqs-en-fiambala"} className={"turismo-cerca"}>
                  <CajaGenerica
                      icon={"question_answer"}
                      titulo={"Preguntas Frecuentes"}
                      texto={"¿Cuáles son las principales atracciones turísticas?\n" +
                          "¿Dónde se recomienda comer?\n" +
                          "¿Cuál es la mejor manera de movilizarse?\n" +
                          "¿Cómo es el clima y cuál es la mejor época para visitar?\n"}
                  />
              </section>

          </div>


          <footer>
              <Pie className={"pie"}/>

          </footer>

      </Router>
  )
      ;
}

export default App;
